import ObjectTypes from 'Lib/constants/app/objectTypes';
import ContactTypes from 'Lib/constants/contacts/contactTypes';

export const WorkOrderSharedObjectTypes = [ObjectTypes.Contact, ObjectTypes.Property, ObjectTypes.Unit];
export const BillSharedObjectTypes = [ObjectTypes.Contact];
export const LeaseSharedObjectTypes = [ObjectTypes.Unit];
export const LeasePaymentSharedObjectTypes = [ObjectTypes.Lease];

export const allowWorkOrderShare = (objectTypeID, contactTypeID) => {
    if (objectTypeID == ObjectTypes.Contact) {
        return contactTypeID == ContactTypes.Vendor;
    }

    return WorkOrderSharedObjectTypes.includes(objectTypeID);
};

export const allowBillShare = (objectTypeID, contactTypeID) => {
    if (objectTypeID == ObjectTypes.Contact) {
        return contactTypeID == ContactTypes.Vendor;
    }

    return BillSharedObjectTypes.includes(objectTypeID);
};

export const allowLeaseShare = objectTypeID => {
    return LeaseSharedObjectTypes.includes(objectTypeID);
};

export const allowLeasePaymentShare = objectTypeID => {
    return LeasePaymentSharedObjectTypes.includes(objectTypeID);
};
